import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaiairporttonashikcab() {



  const cardData = {
    keyword: " Navi Mumbai Airport to Nashik Cab  ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai Airport to Nashik cab service, providing safe, comfortable, and affordable intercity travel for families, pilgrims, business travelers, and tourists. The distance between Navi Mumbai Airport and Nashik is approximately 170–200 km, making it a smooth highway journey via well-connected express routes. Our professional drivers ensure punctual airport pickup, luggage assistance, and a stress-free travel experience with well-maintained vehicles. We offer flexible options including one-way drops, round trips, corporate travel, and customized pilgrimage or leisure packages. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai Airport to Nashik cab service.",

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga",
    "description": "Trimbakeshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva, located near Nashik. It is a major pilgrimage destination where devotees come for darshan, rituals, and spiritual cleansing, especially for Kaal Sarp Dosh and other religious remedies."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous wine estate located near Nashik, offering wine tasting tours, vineyard walks, and scenic views. It is a popular leisure stop for tourists and couples traveling from the airport."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a sacred area in Nashik associated with the Ramayana, where Lord Ram, Sita, and Lakshman are believed to have stayed during exile. It is home to temples like Kalaram Mandir and Sita Gufa."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "Saptashrungi Devi Temple is a powerful Shakti Peetha located near Nashik, situated on a hill and accessible by steps and ropeway. It is an important pilgrimage site for devotees of Goddess Durga."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills is believed to be the birthplace of Lord Hanuman and is a popular trekking destination near Nashik offering scenic views and spiritual significance."
  },
  {
    "title": "Pandav Leni Caves",
    "description": "Pandav Leni Caves are ancient rock-cut Buddhist caves located near Nashik, known for their historical carvings, peaceful environment, and panoramic city views."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund is a sacred bathing ghat on the Godavari River where pilgrims perform rituals and take holy dips. It is one of the most important spiritual sites in Nashik."
  },
  {
    "title": "Gangapur Dam",
    "description": "Gangapur Dam is a scenic water reservoir near Nashik offering peaceful views, picnic spots, and nature experiences for travelers."
  },
  {
    "title": "Nashik City Center",
    "description": "Nashik City Center is a major commercial and residential hub with markets, restaurants, and connectivity to all major tourist and pilgrimage destinations."
  },
  {
    "title": "Coin Museum",
    "description": "The Coin Museum in Nashik showcases India’s numismatic history with ancient coins, exhibits, and educational displays, making it a unique cultural attraction."
  }
],






services: [
  {
    name: "Navi Mumbai to Nashik Cab",
    description: "Navi Mumbai to Nashik cab service offers a comfortable and reliable intercity journey ideal for business travel, family trips, and religious visits. The route is smooth with highway connectivity, ensuring a pleasant ride. Professional drivers and well-maintained vehicles enhance safety. It guarantees a hassle-free travel experience."
  },
  {
    name: "Navi Mumbai Airport to Nashik Cab",
    description: "Navi Mumbai airport to Nashik cab provides direct transfer from airport terminals to Nashik city. Ideal for travelers arriving by flight, this service ensures timely pickup and smooth highway travel. Comfortable vehicles enhance convenience. It guarantees a stress-free journey."
  },
  {
    name: "Navi Mumbai Airport to Nashik Taxi",
    description: "Navi Mumbai airport to Nashik taxi offers private and flexible travel for long-distance journeys. This service includes door-to-door pickup and comfortable seating. Suitable for individuals and groups. It ensures a reliable ride."
  },
  {
    name: "Navi Mumbai Airport to Nashik Cab Service",
    description: "Navi Mumbai airport to Nashik cab service ensures professional transportation with trained drivers and clean vehicles. Ideal for family travel and corporate trips. Flexible booking options enhance convenience. It ensures a safe and smooth journey."
  },
  {
    name: "Taxi from Navi Mumbai Airport to Nashik",
    description: "Taxi from Navi Mumbai airport to Nashik provides dependable intercity travel with experienced drivers. This service ensures smooth highway journeys and timely service. Comfortable seating enhances travel experience. It guarantees reliability."
  },
  {
    name: "Cab from Navi Mumbai Airport to Nashik",
    description: "Cab from Navi Mumbai airport to Nashik offers convenient travel directly from airport arrivals. Ideal for quick transfers after flights. Professional drivers ensure punctual pickups. It ensures a relaxed journey."
  },
  {
    name: "Navi Mumbai to Nashik Cab Fare",
    description: "Navi Mumbai to Nashik cab fare is transparent and budget-friendly based on vehicle type and trip duration. Customers receive clear pricing details before booking. No hidden charges ensure trust. It helps in planning travel costs efficiently."
  },
  {
    name: "Book Cab Navi Mumbai Airport to Nashik",
    description: "Book cab Navi Mumbai airport to Nashik with easy online booking and instant confirmation. Customers can select vehicle type, pickup timing, and location. Transparent pricing ensures reliability. It simplifies travel planning."
  },
  {
    name: "Online Cab Booking Navi Mumbai Airport to Nashik",
    description: "Online cab booking Navi Mumbai airport to Nashik provides a quick and convenient way to reserve your ride. Secure payment and instant confirmation enhance booking experience. Multiple vehicle options are available. It ensures hassle-free booking."
  },
  {
    name: "Best Cab Navi Mumbai Airport to Nashik",
    description: "Best cab Navi Mumbai airport to Nashik ensures top-quality vehicles, professional drivers, and excellent service. This service focuses on comfort, safety, and punctuality. It guarantees a premium travel experience."
  },
  {
    name: "Cheapest Cab Navi Mumbai Airport to Nashik",
    description: "Cheapest cab Navi Mumbai airport to Nashik offers affordable travel options without compromising comfort and safety. Transparent pricing ensures no hidden charges. Ideal for cost-conscious travelers. It ensures economical travel."
  },
  {
    name: "Reliable Taxi Navi Mumbai Airport to Nashik",
    description: "Reliable taxi Navi Mumbai airport to Nashik provides dependable transportation with verified drivers and well-maintained vehicles. This service ensures timely pickups and drops. It guarantees a safe and comfortable journey."
  },
  {
    name: "One Way Cab Navi Mumbai Airport to Nashik",
    description: "One way cab Navi Mumbai airport to Nashik offers cost-effective travel without return charges. Ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Round Trip Cab Navi Mumbai Airport to Nashik",
    description: "Round trip cab Navi Mumbai airport to Nashik provides complete travel solutions including return journeys. Ideal for business trips and pilgrimages. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Airport Pickup Cab Navi Mumbai to Nashik",
    description: "Airport pickup cab Navi Mumbai to Nashik offers seamless pickup from airport terminals with flight tracking support. Professional drivers ensure timely service. Comfortable vehicles enhance travel experience. It ensures a smooth transfer."
  },
  {
    name: "Innova Crysta Cab Navi Mumbai to Nashik",
    description: "Innova Crysta cab Navi Mumbai to Nashik offers premium and spacious travel for families and corporate clients. Luxury interiors and smooth performance enhance long-distance comfort. It ensures a high-end travel experience."
  }
],

tableData: [
  ["Navi Mumbai to Nashik Cab", "Navi Mumbai Airport to Nashik Cab"],
  ["Navi Mumbai Airport to Nashik Taxi", "Navi Mumbai Airport to Nashik Cab Service"],
  ["Taxi from Navi Mumbai Airport to Nashik", "Cab from Navi Mumbai Airport to Nashik"],
  ["Navi Mumbai to Nashik Cab Fare", "Book Cab Navi Mumbai Airport to Nashik"],
  ["Online Cab Booking Navi Mumbai Airport to Nashik", "Best Cab Navi Mumbai Airport to Nashik"],
  ["Cheapest Cab Navi Mumbai Airport to Nashik", "Reliable Taxi Navi Mumbai Airport to Nashik"],
  ["One Way Cab Navi Mumbai Airport to Nashik", "Round Trip Cab Navi Mumbai Airport to Nashik"],
  ["Airport Pickup Cab Navi Mumbai to Nashik", "Innova Crysta Cab Navi Mumbai to Nashik"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Navi Mumbai Airport to Nashik Travel",
    WhyChoosedescription: "Royal Route Cabs offers smooth and comfortable cab service from Navi Mumbai Airport to Nashik, ideal for family trips, business travel, and religious visits."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup with Flight Tracking",
    WhyChoosedescription: "We track flight timings to ensure timely pickup even during delays, providing a stress-free airport transfer experience."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are well-trained in Mumbai–Nashik highway routes, ensuring safe driving and efficient travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport to Nashik cab service operates round the clock for late-night arrivals and early departures."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and sanitized regularly for a comfortable ride."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Airport Transfer Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for reliable airport transfers with punctual service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Navi Mumbai Airport to Nashik cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Navi Mumbai Airport to Nashik." },
  { question: "What is the distance between Navi Mumbai Airport and Nashik?", answer: "The distance is approximately 160 to 180 km and takes around 3.5 to 4.5 hours depending on traffic and route." },
  { question: "What is the cab fare for this route?", answer: "Cab fares typically start from ₹2000 to ₹3200 depending on vehicle type and package." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide one-way cab service?", answer: "Yes, we provide one-way and round-trip cab services." },
  { question: "Do you track flight delays?", answer: "Yes, we track flights to ensure timely pickup." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability." },
  { question: "Do you provide doorstep drop in Nashik?", answer: "Yes, we provide drop to home, hotel, or office anywhere in Nashik." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Omkar Jadhav",
    feedback: "The Navi Mumbai Airport to Nashik cab service with Royal Route Cabs was very smooth and punctual. The driver was professional and ensured a comfortable long-distance journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "Excellent experience traveling from Navi Mumbai Airport to Nashik. The cab was clean, well-maintained, and the ride felt safe and relaxing throughout.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Nashik Cab",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-airport-to-nashik-cab.jpg", // replace if needed
  "description": "Book Navi Mumbai Airport to Nashik cab service with Royal Route Cabs for safe, reliable, and comfortable intercity travel. Available 24x7 with sedan, SUV, Innova, Ertiga, and premium vehicles for airport pickup and drop services.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-airport-to-nashik-cab"
  }
};





  return (
    <div>

<Helmet>
  <title>Navi Mumbai Airport to Nashik Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport to Nashik cab with Royal Route Cabs. Safe and affordable airport transfer taxi service with 24x7 availability, professional drivers, and comfortable vehicles."
  />

  <meta
    name="keywords"
    content="navi mumbai to nashik cab, navi mumbai airport to nashik cab, navi mumbai airport to nashik taxi, navi mumbai airport to nashik cab service, taxi from navi mumbai airport to nashik, cab from navi mumbai airport to nashik, navi mumbai to nashik cab fare, book cab navi mumbai airport to nashik, online cab booking navi mumbai airport to nashik, best cab navi mumbai airport to nashik, cheapest cab navi mumbai airport to nashik, reliable taxi navi mumbai airport to nashik, one way cab navi mumbai airport to nashik, round trip cab navi mumbai airport to nashik"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairporttonashikcab;